import React from 'react';
import ArrowLeftIcon from '@tradera/blueprint/theme/icons2/arrow-left.svg?jsx';
import ArrowRightIcon from '@tradera/blueprint/theme/icons2/arrow-right.svg?jsx';

export const NextArrow = props => {
    const { className, arrowClassName = '', style, onClick } = props;
    return (
        <div
            className={`arrow ${className} ${arrowClassName}`}
            style={{ ...style, display: 'block' }}
            onClick={() => {
                onClick();
            }}>
            <ArrowRightIcon className="icon" />
        </div>
    );
};
export const PreviousArrow = props => {
    const { className, arrowClassName = '', style, onClick } = props;
    return (
        <div
            className={`arrow ${className} ${arrowClassName}`}
            style={{ ...style, display: 'block' }}
            onClick={() => {
                onClick();
            }}>
            <ArrowLeftIcon className="icon" />
        </div>
    );
};
